import styled from 'styled-components';

export const StyledAccordionHeader = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div<{ disabled?: boolean }>`
  opacity: ${({ disabled }) => disabled && '30%'};
`;
